import { useQuery } from "@tanstack/react-query";
import { defiLlama } from "./prices";

const MINUTE = 60 * 1000;

/**
 * Current USD price for a single coin.
 *
 * For the marketing demo, which needs one price and has no trade to hang it
 * off. Cached hard: it is the same figure for every visitor, and DefiLlama is
 * an unmetered public good rather than something to poll per page view.
 *
 * **Lives outside `queries.ts` on purpose.** That module is the app's whole
 * server-data surface, so it imports the Firestore repositories — and the
 * homepage demo importing one hook from it dragged the entire database SDK onto
 * the landing page. The chunk graph is not visible from a call site, so a
 * one-line import was enough to undo the route splitting entirely.
 */
export function useCoinPrice(coinId: string) {
  return useQuery({
    queryKey: ["coinPrice", coinId],
    queryFn: async () => (await defiLlama.currentPrices([coinId])).get(coinId)?.usd ?? null,
    staleTime: 10 * MINUTE,
    retry: 1,
  });
}
